// extracted by mini-css-extract-plugin
module.exports = {"component":"floating-actions-dropdown_component__0LP1D","isDisabled":"floating-actions-dropdown_isDisabled__FvPuV"};